export interface Features {
  enableEmptyState: boolean;
  failingRequestRetriesOnSubmit: number;
}

export function initFeatureFlags(features: Features) {
  features.enableEmptyState = false;
  features.failingRequestRetriesOnSubmit = 10;
}
